<template>
  <nav class="nav">
    <ul class="nav-list">
      <li class="nav-list-item">
        <router-link
          class="nav-list-item-link"
          to="/home"
          exact
          active-class="active"
          >{{ $t('nav.home') }}</router-link
        >
      </li>
      <li class="nav-list-item">
        <router-link
          class="nav-list-item-link"
          to="/about-us"
          exact
          active-class="active"
          >{{ $t('nav.about_us') }}</router-link
        >
      </li>
      <li class="nav-list-item">
        <router-link
          class="nav-list-item-link"
          to="/products"
          exact
          active-class="active"
          >{{ $t('nav.products') }}</router-link
        >
      </li>
      <li class="nav-list-item" v-if="!userInfo">
        <router-link
          class="nav-list-item-link"
          to="/login"
          exact
          active-class="active"
          >{{ $t('nav.customer_center') }}</router-link
        >
      </li>
      <li class="nav-list-item">
        <router-link
          class="nav-list-item-link"
          to="/download-center"
          exact
          active-class="active"
          >{{ $t('nav.download_center') }}</router-link
        >
      </li>
      <li class="nav-list-item">
        <router-link
          class="nav-list-item-link"
          to="/contact-us"
          exact
          active-class="active"
          >{{ $t('nav.contact_us') }}</router-link
        >
      </li>
    </ul>
  </nav>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapState } from 'vuex';

export default defineComponent({
  name: 'Nav',
  props: {
    msg: String
  },
  computed: {
    ...mapState(['userInfo'])
  }
});
</script>

<style scoped lang="scss">
.nav-list {
  display: flex;

  &-item + &-item {
    margin-left: 16px;
  }

  &-item-link {
    font-weight: bold;
    font-size: 11px;
    line-height: 1;
    color: #eeeeee;
    letter-spacing: 0.1px;
  }
}
</style>
